import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
  {
    styedPaper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "8px 24px"
    },
    styledCloudUploadIcon: {
      height: "56px",
      width: "56px"
    },
    styledDragOrDropFilesText: {
      color: "#747C8C",
      fontSize: 18,
      fontWeight: 600,
      marginBottom: 4
    },
    styledOrText: {
      color: "#747C8C",
      fontSize: 18
    },
    selectFileButton: {
      backgroundColor: "#ffdb00",
      color: "#0030ff",
      margin: "14px 24px",
      "& > span": {
        fontWeight: 700
      }
    }
  },
  { name: "UploadComponent" }
);

export default useStyles;
